/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProactiveSupportDashboardRedirectEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const proactiveSupportDashboardRedirectEntryPoint: EntryPoint<
	ProactiveSupportDashboardRedirectEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProactiveSupportDashboardRedirectEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-proactive-support-dashboard-redirect" */ './ProactiveSupportDashboardRedirect.tsx',
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
